/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FunkprotokollEintragRequest { 
    text?: string;
    melder?: string;
    eintrag_id: string;
    fall_id: string;
    meldeart_id: string;
    melde_zeitpunkt_utc?: Date;
    bilder_upload_ids?: Array<string>;
    veranstaltung_id: string;
}

